<!--
 * @Author: mzw
 * @Date: 2021-09-26 13:28:56
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-01-11 19:21:17
 * @Description: 物流信息弹窗组件
-->
<template>
  <el-dialog
    :title="$t('product.logisticsDetail')"
    :visible.sync="logisticsVisible"
    :before-close="handleLogClose"
  >
    <ul class="logistics" v-if="logisticsBasic">
      <li>
        <span class="label">{{$t('product.shipTime')}}：</span>
        <span class="value">{{ logisticsBasic.deliveryDate || '-' }}</span>
      </li>
      <li>
        <span class="label">{{$t('product.shipWay')}}：</span>
        <span class="value">{{ logisticsBasic.logisticsTypeText || '-' }}</span>
      </li>
      <template
        v-if="
          logisticsBasic.logisticsNumber && logisticsBasic.logisticsCompanyName
        "
      >
        <li>
          <span class="label">{{$t('product.shipDto')}}：</span>
          <span class="value">{{
            logisticsBasic.logisticsCompanyName || '-'
          }}</span>
        </li>
        <li>
          <span class="label">{{$t('product.shipNo')}}：</span>
          <span class="value">{{ logisticsBasic.logisticsNumber || '-' }}</span>
        </li>
      </template>
    </ul>
    <div class="list" v-if="logisticsList && logisticsList.length > 0">
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in logisticsList"
          :key="index"
          :type="index === 0 ? 'primary' : 'info'"
          :size="index === 0 ? 'large' : 'normal'"
          :timestamp="item.time"
        >
          {{ item.context }}
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="no-data" v-if="logisticsList && logisticsList.length === 0">
      {{$t('product.noShipInfo')}}
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    logisticsList: {
      type: Array
    },
    logisticsVisible: {
      type: Boolean,
      default: false
    },
    logisticsBasic: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    handleLogClose () {
      this.$emit('handleLogClose')
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  padding: 10px;
  max-height: 400px;
  overflow: auto;
  .item {
    display: flex;
    padding: 4px 0;
    .time {
      width: 130px;
      color: #797979;
    }
    .context {
      flex: 1;
      color: #303133;
      padding-left: 12px;
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #797979;
  border: 1px solid #e5e5e5;
  height: 100px;
}

.logistics {
  margin-top: -20px;
  .label {
    color: #666;
  }
  .value {
    color: #333;
  }
}
</style>
